import { memo } from 'react'
import { Skeleton } from '../../../shared/ui/Skeleton'

export const TopicRowSkeleton = memo(function TopicRowSkeleton() {
  return (
    <div
      style={{
        padding: 24,
        borderRadius: 16,
        border: '1px solid var(--divider)',
        background: 'var(--bg-secondary)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 24,
      }}
    >
      <div style={{ flex: 1 }}>
        <div style={{ display: 'flex', gap: 12, marginBottom: 8 }}>
          <Skeleton className="h-5 w-24 rounded-full" />
        </div>
        <Skeleton className="mb-3 h-7 w-48" />
        <div style={{ display: 'flex', gap: 8 }}>
          <Skeleton className="h-6 w-16" />
          <Skeleton className="h-6 w-20" />
          <Skeleton className="h-6 w-12" />
        </div>
        <Skeleton className="mt-4 h-4 w-40" />
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <Skeleton className="h-10 w-10 rounded-lg" />
        <Skeleton className="h-10 w-10 rounded-lg" />
      </div>
    </div>
  )
})
